import 'babel-polyfill'
import 'whatwg-fetch'
import 'blueimp-canvas-to-blob'
import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import { store } from '@/store'

import './scss/designer.scss'

import { library } from '@fortawesome/fontawesome-svg-core'

import { faUserSecret, faSearchMinus, faSearchPlus, faUndo, faTrashAlt, faArrowsAlt, faShoppingCart, faTimes, faCheck, faPlus, faCheckCircle, faInfoCircle, faCircle, faPlusCircle, faMinusCircle, faExclamationCircle, faAngleLeft, faAngleRight, faChevronCircleRight, faTimesCircle, faCaretLeft, faCaretRight} from '@fortawesome/free-solid-svg-icons'
import { faImage, faTrashAlt as faTrashAltFar } from '@fortawesome/free-regular-svg-icons'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import Vue2TouchEvents from 'vue2-touch-events'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import router from './router'
import resolveSession from './utils/sessionResolver';
import i18n from './i18n'

library.add(faUserSecret, faImage, faFacebookF, faSearchMinus, faSearchPlus, faPlus, faUndo, faTrashAlt, faTrashAltFar, faArrowsAlt, faShoppingCart, faTimes, faCheck, faCheckCircle, faInfoCircle, faCircle, faPlusCircle, faMinusCircle,faExclamationCircle, faAngleLeft, faAngleRight, faChevronCircleRight, faTimesCircle, faCaretLeft, faCaretRight)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('loading', Loading)
Vue.component('vue-slider', VueSlider)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.use(BootstrapVue)
Vue.use(Vue2TouchEvents, {
  disableClick: true,
  touchClass: '',
  tapTolerance: 10,
  touchHoldTolerance: 400,
  swipeTolerance: 30,
  longTapTimeInterval: 400
})

Vue.config.productionTip = false

resolveSession().then(() => {
  new Vue({
    render: h => h(App),
    router,
    i18n,
    store
  }).$mount('#app')
})
